import * as Lottie from 'lottie-web';
import * as $ from 'jquery';
import { LottiePlayer } from 'lottie-web';

$(document).ready(()=>{
    let element = $('[lottie-animation]');

    let alreadyPlayed = element.attr('already-played') !== undefined;

    (Lottie as unknown as LottiePlayer).loadAnimation({
        container: element[0], // the dom element that will contain the animation
        renderer: 'svg',
        loop: false,
        autoplay: !alreadyPlayed,
        initialSegment: alreadyPlayed ? [83, 83] : null,
        path: '/wp-content/themes/wp_goshireland/animations/black-friday.json' // the path to the animation json
      });
})